// @flow
import * as React from "react";
import cx from "classnames";
import styles from "./FieldArrayButtons.scss";
import AddField from "./AddField/AddField";
import RemoveField from "./RemoveField/RemoveField";

type FieldArrayButtonsProps = {
  addField: {
    handleClick: () => void,
    text: () => React.Node,
    isVisible: boolean
  },
  removeField: {
    handleClick: () => void,
    text: () => React.Node,
    isVisible: boolean
  },
  withMargin: boolean
};

const FieldArrayButtons = ({
  addField: { handleClick: handleClickAdd, text: textAdd, isVisible: isVisibleAdd },
  removeField: { handleClick: handleClickRemove, text: textRemove, isVisible: isVisibleRemove },
  withMargin
}: FieldArrayButtonsProps) => (
  <div className={cx(styles.buttonContainer, { [styles.noMargin]: !withMargin })}>
    {isVisibleAdd ? <AddField handleClick={handleClickAdd} text={textAdd} /> : <div />}
    {isVisibleRemove ? <RemoveField handleClick={handleClickRemove} text={textRemove} /> : <div />}
  </div>
);

FieldArrayButtons.defaultProps = {
  addField: {
    handleClick: () => {},
    text: () => null,
    isVisible: false
  },
  removeField: {
    handleClick: () => {},
    text: () => null,
    isVisible: false
  },
  withMargin: true
};

export default FieldArrayButtons;
